import { IKBCatalog, IKBCatalogCategory } from '../interfaces/IBase-knowledge-catalog';

export class KBCatalogFactory {
  private static readonly EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

  static createNew(category?: IKBCatalogCategory): IKBCatalog {
    return {
      Id: this.EMPTY_GUID,
      Expanded: false,
      DisplayName: '',
      Description: '',
      KBArtifacts: [],
      IdParent: category?.Id || this.EMPTY_GUID,
      HasChanges: true
    };
  }

  static createFromModalResult(result: any, catalogId?: string, parentId?: string): IKBCatalog {
    return {
      Id: catalogId || this.EMPTY_GUID,
      Expanded: false,
      DisplayName: result.name,
      Description: result.description,
      KBArtifacts: [],
      IdParent: parentId,
      HasChanges: true
    };
  }
}
